// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'
import { referenceIdSchema } from './ids.zod'
import { blockReferenceSchema } from './references.zod'

export const availabilityCheckBlockReferenceSchema =
  blockReferenceSchema.extend({
    meaning: z.string()
  })

export const pVRooftopNavigatorBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.PV_ROOFTOP),
  required: z.literal(false),
  settings: blockBaseSettingsSchema.and(
    z.object({
      panelLifetimeYears: z.number()
    })
  ),
  references: z.record(referenceIdSchema, availabilityCheckBlockReferenceSchema)
})

export const pVRooftopNavigatorBlockValueSchema = z.object({
  coordinates: z.union([z.string(), z.undefined()]),
  maxArrayAreaMeters2: z.number().optional(),
  maxSunshineHoursPerYear: z.number().optional(),
  solarPanelsUserCount: z.number().optional(),
  panelLifetimeYears: z.number().optional(),
  co2Savings: z.number().optional(),
  maxArrayPanelsCount: z.number().optional()
})
